import store from "../store"

const needAuth = (auth) => auth === true

export default (to, from, next) => {

	const auth = to.meta.requiresAuth

	if (to.fullPath === '/app/integration.apiclient.documentation') {
		return;
	}

	if (from.fullPath == "/app/painel") {
		window.location.href = to.fullPath
	}
	/**
	 * If route doesn't require authentication be normally accessed.
	 */
	// if (!needAuth(auth)) {
	//   if (to.name === 'auth.login') {
	//     store.dispatch('Auth/checkUserToken')
	//       .then(() => {
	//         next({
	//           name: 'home.index'
	//         })
	//       })
	//       .catch(() => {
	//         next()
	//       })
	//   } else {
	//
	//     next()
	//   }
	//   return // return to prevent the code from continuing in its flow
	//   // With this flow `else` or `else if` is not necessary
	// }

	// Se NAO precisa de autenticação
	if (!needAuth(auth)) {
		next()
		return // return to prevent the code from continuing in its flow
		// With thiclss flow `else` or `else if` is not necessary
	}

	/**
	 * Otherwise  if authentication is required login.
	 */
	store
		.dispatch("Auth/checkUserToken")
		.then(() => {
			// There is a token and it is valid
			next() // can access the route
		})
		.catch(() => {
			// No token, or it is invalid
			next({
				name: "auth.login",
				query: { redirect: to.fullPath }
			})
		})
}
